var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",staticStyle:{"background-color":"rgba(0, 0, 0, 0)"},attrs:{"fluid":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }